import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_LEGAL_DISCLAIMER_UPDATE = defineFcm('growth_legal_disclaimer_update')
	.asBoolean()
	.withDefault(false)
	.toConfig();
